import React from 'react';
import { Table } from '@oms/ui-table';
import { VisuallyHidden } from '@oms/ui-visually-hidden';
import { Link } from '@oms/ui-link';
import { mapGics, mapSI } from '@oms/utils';
import { Trans } from '@lingui/macro';

export default (item: any, showNumberOfShares: boolean) => {
  const getSectorName = () => {
    if (item?.GICS_CODE) return mapGics(item?.GICS_CODE);
    if (item?.SECTOR_INDEX_MEMBER_OF)
      return mapSI(item?.SECTOR_INDEX_MEMBER_OF);
    return '-';
  };

  return (
    <Table>
      <caption>
        <VisuallyHidden>
          <Trans>General information</Trans>
        </VisuallyHidden>
      </caption>
      <tbody>
        <tr>
          <th>
            <Trans>Contact</Trans>
          </th>
          <td className="basic-info">
            <dl>
              <dt>
                <VisuallyHidden>
                  <Trans>Company name</Trans>
                </VisuallyHidden>
              </dt>
              <dd>{item.COMPANY_NAME}</dd>
              <dt>
                <VisuallyHidden>
                  <Trans>Ticker</Trans>
                </VisuallyHidden>
              </dt>
              <dd>{item.ITEM}</dd>
              <dt>
                <VisuallyHidden>
                  <Trans>Website</Trans>
                </VisuallyHidden>
              </dt>
              <dd>
                <Link as="a" variant="link" href={`http://${item.COMPANY_URL}`}>
                  {item.COMPANY_URL}
                </Link>
              </dd>
              <dt>
                <VisuallyHidden>
                  <Trans>Phone</Trans>
                </VisuallyHidden>
              </dt>
              <dd>
                <Link as="a" variant="link" href={`tel:${item.TELEPHONE}`}>
                  {item.TELEPHONE}
                </Link>
              </dd>
            </dl>
          </td>
        </tr>
        <tr>
          <th scope="row">
            <b>
              <Trans>ISIN</Trans>
            </b>
          </th>
          <td>{item.ISIN}</td>
        </tr>
        {item?.ORGANSATION_NUMBER && (
          <tr>
            <th scope="row">
              <b>
                <Trans>Organization number</Trans>
              </b>
            </th>
            <td>{item.ORGANISATION_NUMBER}</td>
          </tr>
        )}
        <tr>
          <th scope="row">
            <b>
              <Trans>Sector</Trans>
            </b>
          </th>
          <td>{getSectorName()}</td>
        </tr>
        {showNumberOfShares && (
          <tr>
            <th scope="row">
              <b>
                <Trans>Number of shares</Trans>
              </b>
            </th>
            <td>{item.ISSUED_NUMBER_OF_SHARES}</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};
